import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        const SmallForm = () => import(/* webpackChunkName: "snippet-items-small-form" */ 'components/SnippetTemplate/Items/SmallForm')
        new Vue({
            el: "#" + this.elemId,
            store,
            render: h => h(SmallForm, {props: eval(this.elemId)})
        })
    }
}
